import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap'
import { getinventorySummary } from '../actions/inventoryActions'
import Message from '../components/Message'
import Loader from '../components/Loader'

let inventorysunk = 0
let inventorygross = 0

const Dashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  // Get inventory summary
  const inventorySummary = useSelector((state) => state.inventorySummary)
  const {
    loading,
    error,
    inventoryCount,
    manufacturerCount,
    itemCount,
    inventorycost,
    inventoryvalue
  } = inventorySummary

  if (inventorycost !== undefined) {
    inventorysunk = inventorycost.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    inventorygross = inventoryvalue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
  }

  useEffect(() => {
    if (!userInfo) {
      localStorage.removeItem('qrcodeScan')
      localStorage.removeItem('userInfo')
      navigate('/login')
    } else {
      dispatch(getinventorySummary())
    }
  }, [navigate, userInfo, dispatch])

  return (
    <Container>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {inventoryCount === 0 && <Message variant='info'>None Found</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Row className='my-3'>
            <Col>
              <Card className='text-left'>
                <Card.Header>
                  <h4>Total Inventory</h4>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    There are {inventoryCount} units in the inventory.
                  </Card.Text>
                </Card.Body>
                <Card.Footer className='text-muted'>
                  <LinkContainer to='/inventory'>
                    <Button variant='primary'>Inventory</Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>
            <Col>
              <Card className='text-left'>
                <Card.Header>
                  <h4>Total Items</h4>
                </Card.Header>
                <Card.Body>
                  <Card.Text>There are {itemCount} items.</Card.Text>
                </Card.Body>
                <Card.Footer className='text-muted'>
                  {' '}
                  <LinkContainer to='/items'>
                    <Button variant='primary'>Items</Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
          <Row className='my-3'>
            <Col>
              <Card className='text-left'>
                <Card.Header>
                  <h4>Total Suppliers</h4>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    There are {manufacturerCount} suppliers.
                  </Card.Text>
                </Card.Body>
                <Card.Footer className='text-muted'>
                  {' '}
                  <LinkContainer to='/name'>
                    <Button variant='primary'>Manufacturers</Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>

            <Col>
              <Card className='text-left'>
                <Card.Header>
                  <h4>Total Value</h4>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    The inventory cost is {inventorysunk}
                    <br />
                    The inventory value is {inventorygross}
                  </Card.Text>
                </Card.Body>
                <Card.Footer className='text-muted'>
                  <strong>Value is the number of items at retail price</strong>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  )
}

export default Dashboard
